const Menu = [
  // {
  //   path: "/dashboard",
  //   icon: "fas fa-home",
  //   title: "Dashboard",
  //   children: [
  //     // { path: "/dashboard/home", title: "Home" },
  //     // { path: "/dashboard/reports", title: "Reports" },
  //     { path: "/home", title: "Home" },
  //     { path: "/reports", title: "Reports" },
  //   ],
  // },
  { path: "/home", icon: "fa fa-bar-chart", title: "Analytics" },
  { path: "/UserEmailchat", icon: "fa fa-hdd", title: "Messages", emaillabel : {}},
  //{ path: "/inbox", icon: "fas fa-inbox", title: "STT APP Chat", label: {} },
 
  // {
  //   path: "/qrcodemanagement",
  //   icon: "fas fa-qrcode",
  //   title: "QR Code Management",
  //   children: [
  //     { path: "/article-qrcode", title: "Article QR Code" },
  //     { path: "/personal-QRCode", title: "Personal QR Code" },
  //     { path: "/product-qrcode", title: "Production QR Code" },
  //   ],
  // },

  { path: "/article-qrcode", icon: "fas fa-qrcode", title: "My QR Code" },
  // { path: "/Categories", icon: "fas fa-list", title: "Categories" },
  { path: "/UserProfile", icon: "fas fa-user", title: "User Profile" },
  { path: "/paymentandinvoices",icon: "fa fa-boxes", title: "Packages and billing" },
  { 
    path: "/setting",
    icon: "fas fa-cog",
    title: "Setting",
    children: [
      // { path: "/setting/passwordmanagement", title: "Password" },
      // { path: "/setting/paymentandinvoices", title: "Packages and billing" },
      // { path: "/setting/yourpackagedetail", title: "Your package detail" },
      { path: "/passwordmanagement", title: "Password" },
      { path: "/yourpackagedetail", title: "Your package detail" },


      // { path: '/setting/rolemanagement', title: 'Role management' },
      
      // { path: '/setting/yourpackagedetail', title: '' },
    ],
  },
  {
    path: "/Lifetags.io",
    img: "/assets/img/logo/STT-Logo.png",
    title: "Lifetags.io",
    children: [
      // { path: "/stt/impression", title: "Impression" },
      // { path: "/stt/aboutus", title: "About us" },
      // { path: "/stt/privacypolicy", title: "Term of service and policies" },
      // { path: "/stt/contactandhelp", title: "Contact and help" },
      { path: "/aboutus", title: "About us" },
      { path: "/privacypolicy", title: "Term of service and policies" },
      { path: "/contactandhelp", title: "Contact and help" },
    ],
  },
  {
    path: "/supperadmin",
    img: "/assets/img/logo/STT-Logo.png",
    title: "SuperAdmin",
    children: [
      // { path: "/supperadmin/superdashboard", title: "Home" },
      // { path: "/supperadmin/packages", title: "Packages" },
      // { path: "/supperadmin/users", title: "Users" },
      { path: "/superdashboard", title: "Home" },
      { path: "/packages", title: "Packages" },
      { path: "/users", title: "Users" },
    ],
  },
];

export default Menu;
